import { createContext, useContext, useRef } from 'react';

export const GridContentsColumnContext = createContext();

export const useRegisterGridContentsColumnRow = (rowName) => {
  const context = useContext(GridContentsColumnContext);
  if (!context) throw new Error('useRegisterGridContentsColumnRow must be used within a GridContentsColumnContextProvider');

  const rowRef = useRef(null);
  if (rowRef.current === null) {
    rowRef.current = context.getNextRow(rowName);
  }

  return rowRef.current;
};

export const GridContentsColumnContextProvider = ({
  columnIndex,
  children,
  itemsClassName
}) => {
  const rowCounter = useRef(1);
  const namedRows = useRef({});

  const getNextRow = (rowName) => {
    const current = rowCounter.current;
    rowCounter.current += 1;
    if (rowName) {
      namedRows.current[rowName] = current;
    }
    return current;
  };

  return (
    <GridContentsColumnContext.Provider value={{
      columnIndex,
      rowCounter,
      getNextRow,
      namedRows,
      itemsClassName
    }}>
      {children}
    </GridContentsColumnContext.Provider>
  );
};
